class TC_Channels_Categories {
    constructor (channelsInstance, playerInstance, artsUrl, templateUrl) {
        this.channelsInstance = channelsInstance;
        this.playerInstance = playerInstance;
        this.artsUrl = artsUrl;
        this.templateUrl = templateUrl;
        this.remoteData = null;
        this.expandedContent = $('.calmchristian-channels-expanded');
        this.template = `
            <div class="calmchristian-channels-category is-closed" data-category-id="">
                <h3 class="calmchristian-channels-category-title">
                    <img src="" class="calmchristian-channels-category-thumbnail" alt="" />
                    <span></span>
                </h3>
                
                <div class="calmchristian-channels-category-content">
                    <div class="calmchristian-channels-items">
                    
                    </div>
                </div>
            </div>
        `;

        this.itemTemplate = `
            <div class="calmchristian-channels-item is-visible is-loading" data-channel-id="">
                <img 
                    class="calmchristian-channels-item-helper-image" 
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADCAQAAADxPw1zAAAADklEQVR42mNkgANGrEwAAGMABP93vXMAAAAASUVORK5CYII=" />
            </div>
        `;

        this.initExpandedUI();
    }

    setRemoteData (remoteData) {
        this.remoteData = remoteData;
    }

    generateCategory (rowID, categoryID) {
        let wrapper = $('.calmchristian-channels-genre[data-genre-id="' + parseInt(rowID, 10) + '"]');
        let categoryData = this.remoteData.categories.filter(category => category.id === categoryID);

        if (categoryData.length) {
            categoryData = categoryData[0];
            let categoryElement = $(this.template);
            categoryElement.find('.calmchristian-channels-category-title > span').text(categoryData.title);
            categoryElement.find('.calmchristian-channels-category-thumbnail').attr('src', this.artsUrl + categoryData.tiny_square_art_url);
            categoryElement.attr('data-category-id', parseInt(categoryID, 10));
            wrapper.append(categoryElement);

            setTimeout(() => {
                this.generateItems(categoryData.channels, categoryID);
                categoryElement.find('.calmchristian-channels-category-title').on('click', e => {
                    e.preventDefault();
                    let contentWrapper = categoryElement.find('.calmchristian-channels-category-content');
                    let content = categoryElement.find('.calmchristian-channels-items');
                    let h = content.outerHeight();

                    if (categoryElement.hasClass('is-closed')) {
                        contentWrapper.css('height', h + 'px');
                        categoryElement.removeClass('is-closed');

                        setTimeout(() => {
                            contentWrapper.css('height', 'auto');
                            categoryElement[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                        }, 500);
                    } else {
                        contentWrapper.css('height', h + 'px');

                        setTimeout(() => {
                            contentWrapper.css('height', '0px');
                            categoryElement.addClass('is-closed');
                        }, 0);
                    }

                    if (!e.isTrigger) {
                        let categoriesToClose = categoryElement.parent().find('.calmchristian-channels-category:not(.is-closed)');

                        for (let i = 0; i < categoriesToClose.length; i++) {
                            if (categoriesToClose.eq(i).attr('data-category-id') !== categoryElement.attr('data-category-id')) {
                                categoriesToClose.eq(i).find('.calmchristian-channels-category-title').trigger('click');
                            }
                        }
                    }
                });
            }, 0);
        }
    }

    generateItems (channelsToGenerate, categoryID) {
        let count = channelsToGenerate.length;
        let wrapper = $('.calmchristian-channels-category[data-category-id="' + parseInt(categoryID, 10) + '"] .calmchristian-channels-items');

        for (let i = 0; i < count; i++) {
            let template = $(this.itemTemplate);
            template.attr('data-channel-id', channelsToGenerate[i]);
            template.appendTo(wrapper);
        }

        setTimeout(() => {
            let items = wrapper.find('.calmchristian-channels-item');

            for (let i = 0; i < items.length; i++) {
                items.eq(i).attr('data-index', i);
            }

            this.fillItems(channelsToGenerate, categoryID);
        }, 0);
    }

    fillItems (channels, categoryID) {
        let items = $('.calmchristian-channels-category[data-category-id="' + parseInt(categoryID, 10) + '"] .calmchristian-channels-item');

        for (let i = 0; i < items.length; i++) {
            let itemData = this.remoteData.channels.filter(channel => channel.id === channels[i])[0];
            let channelID = parseInt(itemData.id, 10);
            let img = $('<img class="calmchristian-channels-item-temp-img" src="" style="width:20px;height:20px;opacity:0;position:absolute;">');
            let imgInstance = new Image();
            imgInstance.src = this.artsUrl + itemData.landscape_art_url;
            imgInstance.addEventListener('load', () => {
                this.activateItem(channelID);
            });
            img.attr('src', imgInstance.src);
            img.appendTo(items[i]);
        }
    }

    activateItem (channelID) {
        let channelTitle = this.remoteData.channels.filter(channel => channel.id === channelID)[0].title;
        let item = $('.calmchristian-channels-item[data-channel-id="' + channelID + '"]');
        let bgItem = $('<div class="calmchristian-channels-item-bg"></div>');
        bgItem.css('background-image', 'url(\'' + item.find('img.calmchristian-channels-item-temp-img').eq(0).attr('src') + '\')');
        bgItem.appendTo(item);
        let playItem = $('<a href="#" title="' + window.CSITE_LANGS.channels.texts.ariaPlay + channelTitle + '" class="calmchristian-channels-item-play"><svg width="24" height="24" class="cr-player-play-icon-play"><use xlink:href="' + this.templateUrl + '/images/svg-map.svg#play"></use></svg><svg width="24" height="24" class="cr-player-play-icon-pause"><use xlink:href="' + this.templateUrl + '/images/svg-map.svg#pause"></use></svg></a>');
        let expandItem = $('<div class="calmchristian-channels-item-expand"></div>');
        playItem.appendTo(item);
        expandItem.appendTo(item);
        item.find('img.calmchristian-channels-item-temp-img').remove();

        item.find('.calmchristian-channels-item-bg').on('click', e => {
            e.stopPropagation();
            expandItem.trigger('click');
        });

        playItem.on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            if (!playItem.parent().hasClass('is-played')) {
                $("html, body").animate({ scrollTop: 0 }, 500);
                this.channelsInstance.currentChannelID = channelID;
                this.channelsInstance.currentGenreID = false;
                this.playerInstance.loadChannel(channelID, true);
            } else {
                this.playerInstance.eventPause();
            }
        });

        if (this.remoteData.favorites && this.remoteData.favorites.indexOf(channelID) > -1) {
            item.addClass('is-favorited');
        } else {
            item.removeClass('is-favorited');
        }

        if (this.remoteData.opinions && this.remoteData.opinions[channelID]) {
            if (this.remoteData.opinions[channelID] === 1) {
                item.addClass('is-liked');
                item.removeClass('is-disliked');
            }

            if (this.remoteData.opinions[channelID] === -1) {
                item.addClass('is-disliked');
                item.removeClass('is-liked');
            }
        }

        expandItem.on('click', e => {
            e.stopPropagation();
            let index = parseInt(expandItem.parent().attr('data-index'), 10);
            let allItems = expandItem.parents('.calmchristian-channels-items').find('.calmchristian-channels-item');
            let itemIsExpanded = expandItem.parent().hasClass('is-expanded');
            let itemCategoryID = parseInt(expandItem.parents('.calmchristian-channels-category').attr('data-category-id'), 10);
            let currentRow = parseInt(this.expandedContent.attr('data-current-row'), 10);
            let currentCategoryID = parseInt(this.expandedContent.attr('data-current-category-id'), 10);
            let itemsPerRow = 6;

            if ($(window).outerWidth() <= 540) {
                itemsPerRow = 1;
            } else if ($(window).outerWidth() <= 720) {
                itemsPerRow = 2;
            } else if ($(window).outerWidth() <= 1040) {
                itemsPerRow = 3;
            } else if ($(window).outerWidth() <= 1280) {
                itemsPerRow = 4;
            } else if ($(window).outerWidth() <= 1440) {
                itemsPerRow = 5;
            }

            if (!itemIsExpanded) {
                let expandedItems = $('.calmchristian-channels-item.is-expanded');
                
                if (expandedItems.length) {
                    expandedItems.removeClass('is-expanded');
                    this.expandedContent.find('.calmchristian-channels-expanded-content').addClass('is-hidden');
                    this.expandedContent.find('.calmchristian-channels-expanded-image').addClass('is-hidden');

                    if (Math.floor(index / itemsPerRow) + 1 !== currentRow || itemCategoryID !== currentCategoryID) {
                        this.expandedContent.addClass('is-closed');
                    }

                    setTimeout(() => {
                        if (Math.floor(index / itemsPerRow) + 1 !== currentRow || itemCategoryID !== currentCategoryID) {
                            if (allItems.length >= (Math.floor(index / itemsPerRow) + 1) * itemsPerRow) {
                                let insertIndex = ((Math.floor(index / itemsPerRow) + 1) * itemsPerRow) - 1;
                                this.expandedContent.insertAfter(allItems.eq(insertIndex));
                            } else {
                                this.expandedContent.insertAfter(allItems.last());
                            }

                            this.expandedContent.attr('data-current-row', Math.floor(index / itemsPerRow) + 1);
                            this.expandedContent.attr('data-current-category', itemCategoryID);
                        }

                        setTimeout(() => {
                            expandItem.parent().addClass('is-expanded');
                            this.expandItem(index, channelID, expandedItems.length);
                            clearTimeout(this.closeTimeout);
                        }, 100);
                    }, 500);
                } else {
                    if (Math.floor(index / itemsPerRow) + 1 !== currentRow || itemCategoryID !== currentCategoryID) {
                        if (allItems.length >= (Math.floor(index / itemsPerRow) + 1) * itemsPerRow) {
                            let insertIndex = ((Math.floor(index / itemsPerRow) + 1) * itemsPerRow) - 1;
                            this.expandedContent.insertAfter(allItems.eq(insertIndex));
                        } else {
                            this.expandedContent.insertAfter(allItems.last());
                        }

                        this.expandedContent.attr('data-current-row', Math.floor(index / itemsPerRow) + 1);
                    }

                    expandItem.parent().addClass('is-expanded');
                    this.expandItem(index, channelID, expandedItems.length);
                    clearTimeout(this.closeTimeout);
                }
            } else {
                expandItem.parent().removeClass('is-expanded');
                this.expandedContent.find('.calmchristian-channels-expanded-content').addClass('is-hidden');
                this.expandedContent.find('.calmchristian-channels-expanded-image').addClass('is-hidden');
                this.closeTimeout = setTimeout(() => {
                    this.expandedContent.addClass('is-closed');
                }, 500);
            }
        });

        setTimeout(() => {
            bgItem.addClass('is-loaded');
        }, 100);

        setTimeout(() => {
            item.removeClass('is-loading');
        }, 500);
    }

    initExpandedUI () {
        this.expandedContent.find('.calmchristian-channels-expanded-image img').on('load', () => {
            let imgLoader = this.expandedContent.find('.calmchristian-channels-expanded-image img').attr('src');
            let imgWrapper = this.expandedContent.find('.calmchristian-channels-expanded-image');
            imgWrapper.css('background-image', 'url(\'' + imgLoader + '\')');

            setTimeout(() => {
                imgWrapper.removeClass('is-hidden');
            }, 50);
        });

        this.expandedContent.find('.calmchristian-channels-expanded-content-play').on('click', e => {
            e.preventDefault();

            if ($(e.target).hasClass('is-played')) {
                this.playerInstance.eventPause();
            } else {
                $('html, body').animate({ scrollTop: 0 }, 500);
                this.playerInstance.loadChannel(parseInt($(e.target).attr('data-channel-id'), 10), true);
            }
        });

        this.expandedContent.find('.calmchristian-channels-expanded-content-fav').on('click', e => {
            e.preventDefault();
            let favItem = $(e.target);
            let channelID = favItem.attr('data-channel-id');
            favItem.css('opacity', .25);
            favItem.css('pointer-events', 'none');

            if (!this.expandedContent.hasClass('is-favorited')) {
                if (!this.channelsInstance.user.isVip) {
                    this.channels.systemMessages.showMessage('vipFavorites');
                    return;
                }

                this.channelsInstance.addToFavorites(channelID, () => {
                    this.expandedContent.addClass('is-favorited');
                    favItem.css('opacity', '');
                    favItem.css('pointer-events', 'auto');
                });
            } else {
                if (!this.channelsInstance.user.isVip) {
                    this.channels.systemMessages.showMessage('vipFavorites');
                    return;
                }

                this.channelsInstance.removeFromFavorites(channelID, () => {
                    this.expandedContent.removeClass('is-favorited');
                    favItem.css('opacity', '');
                    favItem.css('pointer-events', 'auto');
                });
            }
        });

        this.expandedContent.find('.calmchristian-channels-expanded-content-like').on('click', e => {
            e.preventDefault();
            let likeItem = $(e.target);
            let channelID = likeItem.attr('data-channel-id');

            if (this.expandedContent.hasClass('is-liked')) {
                return;
            } else {
                likeItem.css('opacity', .25);
                likeItem.css('pointer-events', 'none');

                this.channelsInstance.likeChannel(channelID, () => {
                    this.expandedContent.addClass('is-liked').removeClass('is-disliked');
                    likeItem.css('opacity', '');
                    likeItem.css('pointer-events', 'auto');
                });
            }
        });

        this.expandedContent.find('.calmchristian-channels-expanded-content-dislike').on('click', e => {
            e.preventDefault();
            let dislikeItem = $(e.target);
            let channelID = dislikeItem.attr('data-channel-id');

            if (this.expandedContent.hasClass('is-disliked')) {
                return;
            } else {
                dislikeItem.css('opacity', .25);
                dislikeItem.css('pointer-events', 'none');

                this.channelsInstance.dislikeChannel(channelID, () => {
                    this.expandedContent.addClass('is-disliked').removeClass('is-liked');
                    dislikeItem.css('opacity', '');
                    dislikeItem.css('pointer-events', 'auto');
                });
            }
        });

        this.expandedContent.on('click', e => {
            if ($(e.target).hasClass('channel-chapters-item-link')) {
                e.preventDefault();
                let startTime = parseInt($(e.target).attr('data-start'), 10);
                let channelID = parseInt($(e.target).attr('data-channel-id'), 10);
                $('html, body').animate({ scrollTop: 0 }, 500);
                this.playerInstance.loadChannel(channelID, true, false, startTime);
                this.remoteData.lastListenedChapters[channelID] = parseInt($(e.target).parent().attr('data-chapter-number'), 10);
                this.playerInstance.updateChaptersUI(startTime);
            }

            let dropdown = this.expandedContent.find('.channel-chapters-list-wrapper');

            if ($(e.target).hasClass('channel-chapters-current-item')) {
                e.stopPropagation();
                dropdown.toggleClass('is-closed');

                if (!dropdown.hasClass('is-closed')) {
                    let currentElement = dropdown.find('.is-current');
                    
                    if (currentElement.length) {
                        currentElement[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                }

                return;
            }
        });

        $(document.body).on('click', () => {
            let dropdown = this.expandedContent.find('.channel-chapters-list-wrapper');
            dropdown.addClass('is-closed');
        });
    }

    expandItem (index, channelID, existingOpenedItems) {
        existingOpenedItems = !!existingOpenedItems;
        let itemData = this.remoteData.channels.filter(channel => channel.id === channelID)[0];
        this.expandedContent.find('.calmchristian-channels-expanded-content-play').attr('data-channel-id', channelID);
        this.expandedContent.find('.calmchristian-channels-expanded-content-fav').attr('data-channel-id', channelID);
        this.expandedContent.find('.calmchristian-channels-expanded-content-like').attr('data-channel-id', channelID);
        this.expandedContent.find('.calmchristian-channels-expanded-content-dislike').attr('data-channel-id', channelID);
        this.expandedContent.attr('data-expanded-channel', channelID);

        if (this.remoteData.favorites && this.remoteData.favorites.indexOf(channelID) > -1) {
            this.expandedContent.addClass('is-favorited');
        } else {
            this.expandedContent.removeClass('is-favorited');
        }

        if (this.remoteData.opinions && this.remoteData.opinions[channelID]) {
            if (this.remoteData.opinions[channelID] === 1) {
                this.expandedContent.addClass('is-liked');
            } else {
                this.expandedContent.removeClass('is-liked');
            }

            if (this.remoteData.opinions[channelID] === -1) {
                this.expandedContent.addClass('is-disliked');
            } else {
                this.expandedContent.removeClass('is-disliked');
            }
        } else {
            this.expandedContent.removeClass('is-liked is-disliked');
        }

        setTimeout(() => {
            this.expandedContent.find('h4').text(itemData.title);
            this.expandedContent.find('h4').attr('data-first-letter', itemData.title.substring(0, 1));
            this.expandedContent.find('p').text(itemData.description);
            this.expandedContent.find('.calmchristian-channels-expanded-content').removeClass('is-hidden');
            this.expandedContent.find('.calmchristian-channels-expanded-image').addClass('is-hidden');
            this.expandedContent.find('.calmchristian-channels-expanded-image img').attr('src', this.artsUrl + itemData.hd_landscape_art_url);

            this.expandedContent.find('.calmchristian-channels-slider-expanded-content-chapters').html('');

            if (TC_ChannelChapters.isStoryChannel(this.remoteData, channelID, this.channelsInstance.user.isVip)) {
                this.expandedContent.addClass('is-timetable-loading');
                let storyTimetableUrl = TC_ChannelChapters.getStoryTimetableUrl(this.remoteData, channelID);
                TC_ChannelChapters.getStoryTimetable(this.channelsInstance, storyTimetableUrl, channelID);
            }

            let btn = this.expandedContent.find('.calmchristian-channels-expanded-content-play');

            if (this.playerInstance.playing && this.playerInstance.currentChannel.id === channelID) {
                btn.html(DOMPurify.sanitize(btn.attr('data-text-pause')));
                btn.addClass('is-played');
            } else {
                btn.removeClass('is-played');

                if (this.remoteData.lastListenedChapters && this.remoteData.lastListenedChapters[channelID]) {
                    if (this.remoteData.lastListenedChapters[channelID] === 1 && this.remoteData.finishedStories.indexOf(channelID) > -1) {
                        btn.html(DOMPurify.sanitize(btn.attr('data-text-listen-again')));
                    } else if (this.remoteData.lastListenedChapters[channelID] === 1) {
                        btn.html(DOMPurify.sanitize(btn.attr('data-text-play')));
                    } else {
                        btn.html(DOMPurify.sanitize(btn.attr('data-text-resume')));
                    }
                } else {
                    btn.html(DOMPurify.sanitize(btn.attr('data-text-play')));
                }
            }

            this.expandedContent.removeClass('is-closed');

            setTimeout(() => {
                this.expandedContent[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 500);
        }, existingOpenedItems ? 500 : 0);
    }
}